
  $(document).ready(function(){
  window.supermoment = window.moment
  var momentDate = new moment().tz("America/New_York");
  var currentDayLastOrderTime = new moment().tz("America/New_York").set({'hour': 12, 'minute': 0, 'seconds': 0});
  
  // var fakeDate = '2018-03-19 10:20'; //monday = friday 23
  // var fakeDate = '2018-03-19 15:20'; //monday PM = saturday 24
  // var fakeDate = '2018-03-20 09:20'; //tuesday = saturday 24
  // var fakeDate = '2018-03-20 15:20'; //tuesday PM = monday 26
  // var fakeDate = '2018-03-21 09:20'; //wednesday = monday 26
  // var fakeDate = '2018-03-21 15:20'; //wednesday PM = monday 26
  // var fakeDate = '2018-03-22 09:20'; //thursday = tuesday 27
  // var fakeDate = '2018-03-22 15:20'; //thursday PM = tuesday 27
  // var fakeDate = '2018-03-23 09:20'; //friday = wednesday 27
  // var fakeDate = '2018-03-23 15:20'; //friday PM = friday 30
  // var fakeDate = '2018-03-24 09:20'; //saturday = friday 30
  // var fakeDate = '2018-03-24 15:20'; //saturday PM = friday 30
  // var fakeDate = '2018-03-25 09:20'; //sunday = friday 30
  // var fakeDate = '2018-03-25 15:20'; //sunday = PM friday 30
  
//  var momentDate = moment(fakeDate).tz("America/New_York");
//  var currentDayLastOrderTime = new moment(fakeDate).tz("America/New_York").set({'hour': 12, 'minute': 0});
  
  // standard product transit time
  var processingAndTransitTime = 6; // default: 5
  var additionalText = '';
  
    //  printify canvas transit time
  if ('' == 'Printify' && '' == 'Canvas') {
    processingAndTransitTime = 8;
        additionalText = '';
  }
  
  var dateFormatted = null;
  
  if (momentDate.hour() < 11) {
    var orderByText = "Order With" + momentDate.to(currentDayLastOrderTime);
  }
    
  if (momentDate.hour() > 11) {
    currentDayLastOrderTime = new moment().add(1, 'day').tz("America/New_York").set({'hour': 12, 'minute': 0});
    var orderByText = "Order With" + momentDate.to(currentDayLastOrderTime);
  }
  
    setInterval(function liveCountdown() {
      var a = new supermoment().tz("America/New_York");
      var b = new supermoment().tz("America/New_York").set({'hour': 12, 'minute': 0, 'seconds': 0});
      
      if (a.hour() > 11) {
        b = supermoment().add(1, 'day').tz("America/New_York").set({'hour': 12, 'minute': 0, 'seconds': 0});
      }
      
      var diff = b.diff(a);
      var hours = supermoment.duration(diff).hours();
      var minutes = supermoment.duration(diff).minutes();
      var seconds = supermoment.duration(diff).seconds();

      if (hours !== 0) {
          hours = hours + ' hrs '
      } else {
          hours = '';
      }

      if (minutes !== 0) {
          minutes = minutes + ' mins '
      } else {
          minutes = '';
      }

      seconds = seconds + ' secs '

      var total = 'Order Within ' + hours + minutes + seconds;

      $(".liveDate").html(total);
  }, 1000);
    
  function calculateProcessingAndTransitTime(offset) { 
    
    if (offset == null || offset === 0) {
      offset = 0;
    }

    var dateWithOffset = momentDate.add(processingAndTransitTime + offset, 'd');

    if (dateWithOffset.day() === 0) {
      dateFormatted = momentDate.add(1, 'd').format("dddd, MMMM Do");
    } else {
      dateFormatted = dateWithOffset.format("dddd, MMMM Do");
    }

  }
  
  function mondayToWednesday() {
    // if before midday Monday ~ Wednesday
    if (momentDate.hour() <= 11) {
      calculateProcessingAndTransitTime(1); // default: 1
    } else {
      calculateProcessingAndTransitTime(1); // default: 1
    }
  }

  switch (momentDate.day()) {
    case 0: // Sunday
      calculateProcessingAndTransitTime(1); // default: 1
      break;
    case 1:
      mondayToWednesday(0); // default: 0
      break;
    case 2:
      mondayToWednesday(0); // default: 0
      break;
    case 3:
      mondayToWednesday(0); // default: 0
      break;
    case 4:
      // if ordered on Thursday after Midday
      if (momentDate.hour() > 11) {
        calculateProcessingAndTransitTime(1); // default: 1
      }

      // if ordered on Thursday before Midday
      if (momentDate.hour() <= 11) {
        calculateProcessingAndTransitTime(1); // default: 1
      }
      break;
    case 5:
      // if ordered on Friday after Midday
      if (momentDate.hour() > 11) {
        calculateProcessingAndTransitTime(3); // default: 3
      }

      // if ordered on Friday before Midday
      if (momentDate.hour() <= 11) {
        calculateProcessingAndTransitTime(2); // default: 2
      }
      break;
    case 6:
      // if ordered on Saturday
      calculateProcessingAndTransitTime(2); // default: 2
      break;
    default:
  }
  
  // run functions
  displayDeliveryDate();
  
  // run every 60 seconds
  setInterval(displayDeliveryDate, 1000 * 60);
  
  // display
  function displayDeliveryDate(){
    $("#additionalText").replaceWith(additionalText);
    $("#orderByDate").replaceWith(orderByText);
    $("#getItDate").replaceWith(dateFormatted);
  };
  
});